import companyLogo from 'assets/funnel/power_serv.jpg';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

import heroImg from 'assets/funnel/lager_822_hero_1.jpg';
import infoHeroImg from 'assets/funnel/lager_822_info_1.jpg';
import jobDetailsImg from 'assets/funnel/lager_822_info_2.jpg';
import groupImg from 'assets/funnel/lager_822_info_3.jpg';

const lager_926 = {
  documentTitle: "Lagerarbeiter (m/w/d) für Kommissioniertätigkeiten | POWERSERV Austria GmbH",
  companyLogo,
  companyName: "POWERSERV Austria GmbH",
  aiDisclaimer,

  landing: {
    heroImg,
    chipText: "€ 2.304,60 / Monat",
    heroTitle: "Lagerarbeiter (m/w/d) · Vollzeit",
    heroSubtitle: "Durchführen von Kommissioniertätigkeiten in Tirol / Rietz – starte jetzt durch.",
    facts: [
      { icon: 'bi-cash-stack',    title: '€ 2.304,60 / Monat',      subtitle: 'Brutto-Mindestlohn · Vollzeit' },
      { icon: 'bi-geo-alt-fill',  title: 'Tirol / Rietz',           subtitle: 'Standort' },
      { icon: 'bi-luggage',       title: 'Sabbatical möglich',       subtitle: 'mehrmonatige Auszeit' },
      { icon: 'bi-apple',         title: 'Gratis Verpflegung',      subtitle: 'Obst, Gemüse, Kaffee & Tee' },
    ],
  },

  info: {
    heroImg: infoHeroImg,
    heroChip: "Vollzeit · Lager & Kommissionierung",
    heroTitleLines: ["Lagerarbeiter", "(m/w/d)"],
    facts: [
      { value: "€ 2.304", label: "Brutto-Mindestlohn + Überzahlung möglich" },
      { value: "Vollzeit", label: "Tirol / Rietz" },
    ],
    moechtestDuItems: [
      { icon: 'bi-box-seam',   text: 'Kommissioniertätigkeiten im Trocken-, Kühl- und Tiefkühlbereich übernehmen?' },
      { icon: 'bi-headset',    text: 'mit modernsten sprachgesteuerten Systemen arbeiten und Waren für Filialbelieferungen zusammenstellen?' },
      { icon: 'bi-bicycle',    text: 'von Vorteilen wie E-Bike-Leasing, DU-Kultur und der Möglichkeit eines mehrmonatigen Sabbaticals profitieren?' },
    ],
    benefits: [
      { icon: 'bi-cash-stack',  title: '€ 2.304,60 Mindestlohn',    desc: 'Brutto pro Monat auf Basis Vollzeitbeschäftigung – bei entsprechender Qualifikation oder Erfahrung ist eine Überzahlung möglich.' },
      { icon: 'bi-moon-stars',  title: 'Nachtzulage',               desc: 'Gegebenenfalls Nachtzulage.' },
      { icon: 'bi-book',        title: 'Umfangreiche Einarbeitung',  desc: 'Umfangreiche Einarbeitung inklusive.' },
      { icon: 'bi-apple',       title: 'Kostenlose Verpflegung',    desc: 'Täglich frisches Obst und Gemüse, Kaffee sowie Tee – kostenlos.' },
      { icon: 'bi-bicycle',     title: 'Fahrrad- & E-Bike-Leasing', desc: 'Leasingprogramm für Fahrräder und E-Bikes.' },
      { icon: 'bi-luggage',     title: 'Sabbatical möglich',        desc: 'Möglichkeit von mehrmonatigen Sabbaticals.' },
    ],
    aufgabenTitle: "Lager neu gedacht.",
    tasks: [
      'Durchführen von Kommissioniertätigkeiten im Trocken-, Kühl- und Tiefkühlbereich',
      'Zusammenstellen von Waren für die Filialbelieferungen mit modernsten sprachgesteuerten Systemen',
      'Transportieren der Artikel innerhalb des Lagerbereichs mit elektrisch betriebenen Flurförderfahrzeugen',
      'Händisches Beladen der zu kommissionierenden Paletten',
      'Aktives Unterstützen bei unterschiedlichen Lagertätigkeiten',
    ],
    requirements: [
      'Grundlegende Deutsch- oder Englischkenntnisse',
      'Kein Staplerschein erforderlich',
      'Zuverlässige und selbstständige Arbeitsweise',
      'Bereitschaft zu körperlich anspruchsvollen Tätigkeiten',
      'Teamfähigkeit und Belastbarkeit',
    ],
    jobDetailsImg,
    jobDetailsTagLines: ["Modernes Lager", "in Tirol"],
    noteText: "Aktives Unterstützen bei unterschiedlichen Lagertätigkeiten – mit modernster Technik und umfangreicher Einarbeitung.",
    groupImg,
    finalCtaTitle: "Dann bist du bei uns genau richtig!",
    finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
  },

  quiz: {
    handshakeImg,
  },
};

export default lager_926;
